import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { DELETE_ANAGRAFICA } from '../../data.const';
import {
  retrieveAnagraficaListAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const deleteAnagraficaEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(DELETE_ANAGRAFICA),
    map(({ payload: { ids, isCestino, ...rest } }: any) => ({
      body: {
        ids,
        isCestino,
      },
      listBody: { ...rest, isCestino },
    })),
    // tap(p => console.log(`[epic ${DELETE_ANAGRAFICA}]`, p)),
    withLatestFrom(state$),
    switchMap(([{ body, listBody }, _state]) => {
      return concat(
        of(setLoaders({ anagraficaLoader: true })),
        defer(() =>
          from(
            request({ path: `anagrafica`, method: httpMethods.DELETE, body })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p;
            }),
            // tap(p => console.log(`[epic ${DELETE_ANAGRAFICA}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(() => of(retrieveAnagraficaListAction(listBody))),
            catchError(err => {
              console.error(`[epic ${DELETE_ANAGRAFICA}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ anagraficaLoader: false }))
      );
    })
  );

export default deleteAnagraficaEpic;
